import React from "react";
import SearchTable from "../../../primer/Search-Table";
import {useTranslation} from "../../../../hooks/useTranslation";

const BankSearch = () => {
    const {t} = useTranslation();

    const scColumns = [
        {
            name: t('BankAccountsSearch.table.name'),
            field: "name",
            width: "10%",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('BankAccountsSearch.table.bank'),
            field: "bankName",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('BankAccountsSearch.table.iban'),
            field: "iban",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('BankAccountsSearch.table.date'),
            field: "date",
            editable: false,
            inputType: {
                type: 'date',
            }
        },
        {
            name: t('General.bankingConnected'),
            field: "bankingConnected",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
    ]

    const searchBankAccountsFilters = {
        filters: [
            {
                name: "name",
                label: t('BankAccountsSearch.name'),
                type: "input",
            },
            {
                name: "iban",
                label: t('BankAccountsSearch.iban'),
                type: "input",
            },
            {
                name: "bankName",
                label: t('BankAccountsSearch.bank'),
                type: "input",
            },
            {
                name: "showInactive",
                label: t('General.includeInactive'),
                type: "showInactiveCheckbox",
            },
        ],
        actions: ["quick-edit", "delete"],
    };

    return (
        <div>
            <SearchTable
                tableName="Bank Account Search"
                key={"Bank Account Search"}
                hideYearFilter={true}
                allowToggleColumns={true}
                allowPrintResults={true}
                dataEndpoint={"/cash/list-bank-accounts"}
                exportFileName={"Τραπεζικοί Λογαριασμοί"}
                columns={scColumns}
                data={[]}
                filtersConfig={searchBankAccountsFilters}
            />
        </div>
    )
}

export default BankSearch;
